import { inject, Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { throwError as observableThrowError } from "rxjs/internal/observable/throwError";
import { Router } from "@angular/router";
import { RoutesService } from "../routes.service";

@Injectable({
  providedIn: 'root'
})
export class ResponseStatusInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private routes = inject(RoutesService);

  private redirectStatuses: number[] = [401];


  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError( body => {
        if (this.shouldBeRedirected(body)) {
          this.router.navigate(this.routes.authLogin());
          return next.handle(req);
        }

        return observableThrowError(body);
      }))
  }

  private shouldBeRedirected(resp): boolean {
    return this.redirectStatuses.includes(resp.status);
  }
}
